import React from 'react';

import cn from 'classnames';

import styles from './OnboardSteps.module.scss';

interface OnboardStepsProps {
  className?: string;
}

export const OnboardSteps: React.FC<OnboardStepsProps> = (
  props: OnboardStepsProps
) => {
  const { className } = props;
  const steps = [
    'Copy your invitation link',
    'Reach out to your sponsor by email or chat',
    'Once they’ve set up their Huzzle account we will notify you to select a plan for them',
  ];

  return (
    <div className={cn(styles.onboardSteps, className)}>
      {steps.map((step, index) => (
        <div key={index} className={styles.onboardStepsStep}>
          <div className={styles.stepCount}>
            <p>{index + 1}</p>
          </div>
          <p className={styles.stepData}>{step}</p>
        </div>
      ))}
      <div className={styles.onboardStepsArrow}></div>
    </div>
  );
};
